module.exports = {
    request: function(req, token) {

        req.params = req.params || {};
        req.params['authToken'] = token;

    },

    response: function({ data }) {
        return data.auth_token
    },
};